export enum LoginMode {
  CREATE = 'CREATE',
  LOGIN = 'LOGIN',
}
